
import { axios } from "../api/axios"
import { createAxiosCRMInstance } from "../api/axiosCRM"
import { createAxiosNewInstance } from "../api/axiosNew"

export const callRepsiteAPI= async (userId:any)=>{
   return await axios.get(`stream/host/repsites/${userId}`)
}

export const callConfigurationAPI= async (streamId:any)=>{
    return await axios.get(`stream/configuration/${streamId}`)
}

export const callEvent = async (payload: any) => {
    return await axios.post('events', payload);
}

export const callCreateStreamAPI = async () => {
    return await axios.post('stream/create',{provider: "agora"})
}

export const callCreateTokenAPI = async (stream_instance_id: string, stream_vendor_user_id: number) => {
    return await axios.post('stream/token',{stream_instance_id: stream_instance_id, stream_vendor_user_id: stream_vendor_user_id})
}

export const callEndStreamAPI = async () => {
    return await axios.post('stream/end',{provider: "agora"})
}

export const callStreamInfo = async (streamId: string) => {
    return await axios.get('stream/info/'+streamId)
}

export const callJoinStreamV2 = async (streamId: string, payload: any) => {
    return await axios.post('v2/stream/join/'+streamId, payload)
}

export const callJoinStream = async (streamId: string, payload: any) => {
    return await axios.post('stream/join/'+streamId, payload)
}

export const callAddContact = async (payload: any, url: any, token: any) => {
    var axiosNew = createAxiosNewInstance('https://api-live.hussle.net');
    var composedPayload =
    {
        payload: payload,
        url: url,
        token: token
    }
    return await axiosNew.post('/api/contacts/add', composedPayload);
}

export const callJoinStreamWithAttendeeId = async (streamId: string, attendeeId: string) => {
    return await axios.get('v2/stream/join/'+streamId+'/'+attendeeId);
}

export const callLeaveStreamWithAttendeeId = async (streamId: string, attendeeId: string) => {
    return await axios.get('stream/leave/'+streamId+'/'+attendeeId);
}

export const callAttendeeToken = async (streamId: string, payload: any) => {
    return await axios.post('stream/token/'+streamId, payload);
}

export const callGetRTMToken = async (streamId: string, isHost: boolean) => {
    if (isHost) {
        return await axios.post('chat/token');
    } else {
        return await axios.post('chat/token/'+streamId);
    }
}

export const checkIframeable = async (url: string) => {
    return await axios.post('/iframe/validate', {target_url: url});
}

export const callPostAttendeeNumber = async (streamId: string, attendeeNum: number) => {
    return await axios.post('/stream/attendees/'+streamId, {attendees_current: attendeeNum});
}  
